import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, obj=auth
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (username, password) => {
    const { data } = await api.post("/auth/login", { username, password });
    if (data.token) localStorage.setItem("token", data.token);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, logout, loading, refresh: check }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function hasRole(user, ...roles) {
  return !!user && roles.includes(user.role);
}

/** Supplier identity is confidential. Only admin sees the word "Supplier";
 * everyone else just sees a "Code" (ABLE, NISHA…) with no hint of what it is. */
export function useLabels() {
  const { user } = useAuth();
  const admin = user?.role === "admin";
  return {
    isAdmin: admin,
    Source: admin ? "Supplier" : "Code",
    Sources: admin ? "Suppliers" : "Codes",
    source: admin ? "supplier" : "code",
    tradeName: admin ? "Supplier's name" : "Other name",
    tradeNameLower: admin ? "supplier" : "other name",
  };
}
